export var prefix = 'n3__vision__';
export var modal = "".concat(prefix, "modal");
export var modalDialogWrapper = "".concat(modal, "__dialog-wrapper");
export var modalDialog = "".concat(modal, "__dialog");
export var modalBackdrop = "".concat(modal, "__backdrop");
export var settingsPanel = "".concat(prefix, "settings-panel");
export var settingsPanelGroups = "".concat(settingsPanel, "__groups");
export var settingsPanelButtons = "".concat(settingsPanel, "__buttons");
export var settingsPanelButtonsRight = "".concat(settingsPanel, "__buttons-right");
export var settingsGroup = "".concat(prefix, "settings-group");
export var settingsGroupLabel = "".concat(settingsGroup, "__label");
export var settingsGroupButtons = "".concat(settingsGroup, "__buttons");
export var settingsButton = "".concat(prefix, "settings-button");
export var settingsButtonSelected = "".concat(settingsButton, "_selected");
export var colorButton = "".concat(prefix, "color-button");
export var colorButtonColorPrefix = "".concat(colorButton, "_color_");
export var colorButtonSelected = "".concat(colorButton, "_selected");
export var actionButton = "".concat(prefix, "action-button");